import r from "react";
const d = (t, i) => {
  if (r.isValidElement(t)) {
    const e = i(t);
    if (r.isValidElement(e) && typeof e.props == "object") {
      const n = r.Children.map(
        e.props.children,
        (p) => d(p, i)
      );
      return r.cloneElement(e, {
        ...e.props,
        children: n
      });
    }
    return e;
  }
  return t;
};
export {
  d as updateChildrenRecursively
};
//# sourceMappingURL=updateChildrenRecursively.mjs.map
